<template>
  <header v-editable="props.headerData" class="header-inline">
    <div>
      <HeaderBackground :image="props.headerData.mobile_image" />
      <div class="heading">
        <h2 class="h5">{{ props.headerData.title }}</h2>
        <WizcoTooltip
          v-if="props.headerData.infotext?.length > 0"
          :blok="props.headerData.infotext[0]"
        />
      </div>
    </div>
    <WizcoRichtextResolver
      v-if="props.headerData.subtitle"
      class="content"
      :blok="props.headerData.subtitle"
    />
  </header>
</template>

<script setup>
import HeaderBackground from './HeaderBackground.vue'

const props = defineProps({
  headerData: {
    type: Object,
    required: true
  }
})
</script>

<style scoped>
.header-inline .heading {
  position: relative;
  display: flex;
  gap: 1rem;
}

.header-inline .heading .infotooltip {
  flex-shrink: 0;
}

.header-inline .heading h1 {
  font-weight: 900;
  color: var(--blue);
}

.header-inline figure + .heading {
  margin-left: -20px;
  width: 50%;
}

.header-inline .content > :empty {
  margin-block: 0;
}
</style>
